<template>
    <div class="h-full text-zinc-800 dark:text-white" id="side-bar" :class="dataOpenSideBar ? 'side-bar-visible' : 'side-bar-close'"> 
        <div class="h-[56px] sidebar-brand-row cursor-pointer" @click="$router.push({ name: 'dashboard' })">
            <div class="text-xl font-bold text-center flex items-center justify-center text-zinc-900 dark:text-white h-full" v-show="!dataOpenSideBar">
                <img src="../assets/img/logo_p.png" class="h-12 logo-invert" alt="Vybroo Panel">
            </div>
            <div class="text-xl font-bold text-center flex items-center justify-center text-zinc-900 dark:text-white h-full" v-show="dataOpenSideBar">
                <img src="../assets/img/logo_w.png" class="h-12 logo-invert" alt="Vybroo Panel">
            </div>
        </div>
        <div class="sidebar-content flex flex-col justify-between bg-transparent">
            <div class="menu-man text-left px-2 whitespace-nowrap">
                <div class="sidebar-buttons">
                    <div v-for="section in groupedMenuSections" :key="section.key" class="menu-section-block mb-3">
                        <div v-show="dataOpenSideBar" class="menu-section-title px-2 pt-2 pb-1">{{ section.title }}</div>
                        <div v-for="item in section.items" :key="item.id" class="rounded-sm cursor-pointer text-[#0f1338] hover:text-[#0f1338] dark:text-gray-300 dark:hover:text-white">
                            <router-link
                                v-if="!item.items"
                                :to="item.route"
                                class="list-button-sb px-2 py-3 flex items-center"
                                :class="[isActiveRoute(item.route) ? 'Selected_Sidebar' : '', dataOpenSideBar ? 'sidebar-link-open' : 'sidebar-link-closed']"
                            >
                                <span v-tooltip.right="item.label" class="menu-icon-wrap">
                                    <img v-if="item.svgIcon" :src="item.svgIcon" alt="" class="w-4 h-4 sidebar-icon" />
                                    <font-awesome-icon v-else :icon=item.icon />
                                </span>
                                <span class="sp-text" v-show="dataOpenSideBar" >{{ item.label }}</span>
                            </router-link>

                            <div v-else class="">
                                <div
                                    class="px-2 py-3 flex items-center sidebarPadre hover:bg-zinc-200 dark:hover:bg-zinc-800 rounded-sm transition-colors"
                                    :class="dataOpenSideBar ? 'justify-between' : 'justify-center'"
                                    @click="toggleExpand(item.id)"
                                    :aria-expanded="isExpanded(item.id)"
                                >
                                    <div class="flex items-center" :class="dataOpenSideBar ? 'menu-parent-content-open' : 'menu-parent-content-closed'">
                                        <span v-tooltip.right="item.label" class="menu-icon-wrap">
                                            <img v-if="item.svgIcon" :src="item.svgIcon" alt="" class="w-4 h-4 sidebar-icon" />
                                            <font-awesome-icon v-else :icon=item.icon />
                                        </span>
                                        <span class="sp-text" v-show="dataOpenSideBar">{{ item.label }}</span>
                                    </div>
                                    <span v-show="dataOpenSideBar" class="transition-transform duration-200 ml-2" :class="{ 'rotate-180': isExpanded(item.id) }">
                                        <font-awesome-icon icon="fa-solid fa-chevron-down" class="text-xs" />
                                    </span>
                                </div>

                                <transition
                                    name="collapse"
                                    @enter="enter"
                                    @after-enter="afterEnter"
                                    @leave="leave"
                                >
                                    <div v-show="isExpanded(item.id)" class="overflow-hidden">
                                        <div v-for="item2 in item.items" :key="item2.id">
                                            <div class="rounded-sm cursor-pointer text-[#0f1338] hover:text-[#0f1338] dark:text-gray-300 dark:hover:text-white" :class="dataOpenSideBar ? 'sidebarHijo' : 'sidebarHijoClosed'">
                                                <router-link
                                                    :to="item2.route"
                                                    class="list-button-sb px-2 py-3 flex items-center"
                                                    :class="[isActiveRoute(item2.route) ? 'Selected_Sidebar' : '', dataOpenSideBar ? 'sidebar-link-open' : 'sidebar-link-closed']"
                                                >
                                                    <span v-tooltip.right="item2.label" class="menu-icon-wrap">
                                                        <img v-if="item2.svgIcon" :src="item2.svgIcon" alt="" class="w-4 h-4 sidebar-icon" />
                                                        <font-awesome-icon v-else :icon=item2.icon />
                                                    </span>
                                                    <span class="sp-text" v-show="dataOpenSideBar">{{ item2.label }}</span>
                                                    <span v-if="item2.badge && dataOpenSideBar" class="menu-badge">{{ item2.badge }}</span>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CTA externo (visible para todos los usuarios) -->
        <div class="sidebar-cta">
            <a
                :href="managerHref()"
                target="_blank"
                rel="noopener noreferrer"
                class="sidebar-manager-btn"
                :class="dataOpenSideBar ? 'sidebar-manager-open' : 'sidebar-manager-closed'"
            >
                <span v-tooltip.right="'Ir al manager'" class="menu-icon-wrap">
                    <font-awesome-icon icon="fa-solid fa-arrow-up-right-from-square" />
                </span>
                <span class="sp-text" v-show="dataOpenSideBar">Ir al manager</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Sidebar',
    props: {
        dataOpenSideBar: Boolean
    },
    data() {
        return {
            user_permission: [],
            currentPath: '',
            expandStrategy: 'active',
            menuSectionOrder: ['operations', 'finance', 'indicators', 'ia'],
            menuSectionTitles: {
                operations: 'Operaciones',
                finance: 'Finanzas',
                indicators: 'Indicadores',
                ia: 'Laboratorio IA'
            },
            menuMetaByKey: {
                '/dashboard': { section: 'operations', order: 10 },
                '/solicitudes': { section: 'operations', order: 20, hidden: true },
                '/solicitudes-create': { section: 'operations', order: 30, hidden: true },
                '/cabina': { section: 'operations', order: 40, hidden: true },
                '/videos': { section: 'operations', order: 50, hidden: true },
                '/banners': { section: 'operations', order: 60 },
                '/videos-on-demand': { section: 'operations', order: 70 },
                '/audios': { section: 'operations', order: 80, hidden: true },
                '/paquetes': { section: 'operations', order: 90, hidden: true },
                '/reportes': { section: 'operations', order: 100, hidden: true },
                '/canales-enlaces': { section: 'operations', order: 105 },
                '/logs': { section: 'operations', order: 110, hidden: true },
                '/secuencias': { section: 'operations', order: 120, hidden: true },
                '/relojes': { section: 'operations', order: 130, hidden: true },
                '/eventos': { section: 'operations', order: 140, hidden: true },
                '/concursos': { section: 'operations', order: 150, hidden: true },
                '/formulas': { section: 'operations', order: 160, hidden: true },
                '/relojesmusica': { section: 'operations', order: 170, hidden: true },
                '/tags': { section: 'operations', order: 180 },
                '/categorias-musicales': { section: 'operations', order: 185 },
                '/dispositivos-etiquetas': { section: 'operations', order: 187 },
                '/dispositivos-logs': { section: 'operations', order: 188 },
                '/catalogos': { section: 'operations', order: 190, hidden: true },
                '/usuarios': { section: 'operations', order: 200 },
                '/correos-adeudos': { section: 'finance', order: 210 },
                '/deudas-pagar': { section: 'finance', order: 220 },
                '/facturacion-pendiente': { section: 'finance', order: 230 },
                'Reportes Admon': { section: 'finance', order: 240 },
                'Análisis': { section: 'finance', order: 250 },
                'Gastos': { section: 'finance', order: 260 },
                'Facturas': { section: 'finance', order: 270 },
                '/indicadores/operaciones/canales':   { section: 'indicators', order: 500 },
                '/indicadores/operaciones/llamadas-minutas': { section: 'indicators', order: 510 },
                '/indicadores/operaciones/kpi':        { section: 'indicators', order: 520 },
                '/indicadores/operaciones/analitica':  { section: 'indicators', order: 525 },
                'Operaciones':                        { section: 'indicators', order: 500 },
                '/produccion-ia': { section: 'ia', order: 300, hidden: true }
            },
            expandedItems: {}, // Track which parent items are expanded
            SideBarItems: [
                {
                    icon: 'fa-solid fa-gauge-high',
                    label: 'Dashboard',
                    route: '/dashboard',
                    permissions: []
                },
                {
                    icon: 'fa-solid fa-robot',
                    label: 'Produccion con IA',
                    route: '/produccion-ia',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-list',
                    label: 'Lista solicitudes',
                    route: '/solicitudes',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-plus',
                    label: 'Crear solicitud',
                    route: '/solicitudes-create',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-microphone',
                    label: 'Grabaciones cabina',
                    route: '/cabina',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-video',
                    label: 'Videos',
                    route: '/videos',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-video',
                    label: 'Banners',
                    route: '/banners',
                    permissions: ['visual_content', 'radios', 'admin']
                },
                {
                    icon: 'fa-solid fa-film',
                    label: 'Videos a demanda',
                    route: '/videos-on-demand',
                    permissions: ['create']
                },
                {
                    svgIcon: require('@/assets/svg/reports.svg'),
                    label: 'Reportes',
                    route: '/reportes',
                    permissions: ['admin']
                },
                {
                    svgIcon: require('@/assets/svg/reports.svg'),
                    label: 'Canales y enlaces',
                    route: '/canales-enlaces',
                    permissions: ['reports']
                },
                {
                    icon: 'fa-solid fa-book',
                    label: 'Logs reproducción',
                    route: '/logs',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-diagram-next',
                    label: 'Secuencias',
                    route: '/secuencias',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-clock',
                    label: 'Relojes contenidos',
                    route: '/relojes',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-calendar',
                    label: 'Eventos',
                    route: '/eventos',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-award',
                    label: 'Concursos',
                    route: '/concursos',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-bullhorn',
                    label: 'Audios en demanda',
                    route: '/audios',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-inbox',
                    label: 'Paquetes spots',
                    route: '/paquetes',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-flask',
                    label: 'Fórmulas musicales',
                    route: '/formulas',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-clock',
                    label: 'Relojes música',
                    route: '/relojesmusica',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-compact-disc',
                    label: 'Tags musicales',
                    route: '/tags',
                    permissions: ['tags']
                },
                {
                    icon: 'fa-solid fa-image',
                    label: 'Categorías musicales',
                    route: '/categorias-musicales',
                    permissions: ['tags', 'admin']
                },
                {
                    icon: 'fa-solid fa-tag',
                    label: 'Dispositivos',
                    route: '/dispositivos-etiquetas',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-microchip',
                    label: 'Reg. Dispositivos',
                    route: '/dispositivos-logs',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-list',
                    label: 'Catalogos',
                    route: '/catalogos',
                    permissions: ['admin']
                },
                {
                    icon: 'fa-solid fa-user',
                    label: 'Usuarios',
                    route: '/usuarios',
                    permissions: ['users', 'admin']
                },
                {
                    icon: 'fa-solid fa-envelope',
                    label: 'Correos adeudos',
                    route: '/correos-adeudos',
                    permissions: ['view_finance','admin']
                },
                {
                    icon: 'fa-solid fa-wallet',
                    label: 'Deudas por pagar',
                    route: '/deudas-pagar',
                    permissions: ['view_finance', 'admin']
                },
                {
                    icon: 'fa-solid fa-file-invoice-dollar',
                    label: 'Facturación pendiente',
                    route: '/facturacion-pendiente',
                    permissions: ['view_finance', 'admin']
                },
                {
                    icon: 'fa-solid fa-chart-line',
                    label: 'Reportes Admon',
                    permissions: ['view_finance'],
                    items: [
                        {
                            icon: 'fa-solid fa-scale-balanced',
                            label: 'Situación financiera',
                            route: '/situacion-financiera',
                            permissions: ['view_finance', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-chart-line',
                            label: 'Cuentas anuales',
                            route: '/cuentas-anuales',
                            permissions: ['view_finance', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-chart-pie',
                            label: 'Indicadores',
                            route: '/indicadores-administracion',
                            permissions: ['view_finance','reports']
                        }
                    ]
                },
                {
                    icon: 'fa-solid fa-magnifying-glass-chart',
                    label: 'Análisis',
                    permissions: ['view_finance', 'admin'],
                    items: [
                        {
                            icon: 'fa-solid fa-money-bills',
                            label: 'Análisis gastos',
                            route: '/analisis-gastos',
                            permissions: ['view_finance', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-file-invoice-dollar',
                            label: 'Análisis facturas',
                            route: '/analisis-facturas',
                            permissions: ['view_finance', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-hand-holding-dollar',
                            label: 'Análisis pagos',
                            route: '/analisis-pagos',
                            permissions: ['view_finance', 'admin']
                        }
                    ]
                },
                {
                    icon: 'fa-solid fa-receipt',
                    label: 'Gastos',
                    permissions: ['view_expenses', 'admin'],
                    items: [
                        {
                            icon: 'fa-solid fa-folder-tree',
                            label: 'Categorías gastos',
                            route: '/categorias-gastos',
                            permissions: ['expense_categories', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-file-circle-plus',
                            label: 'Registrar gasto',
                            route: '/registrar-gasto',
                            permissions: ['register_expenses', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-table-list',
                            label: 'Ver gastos',
                            route: '/ver-gastos',
                            permissions: ['view_expenses', 'admin']
                        }
                    ]
                },
                {
                    svgIcon: require('@/assets/svg/invoices_show.svg'),
                    label: 'Facturas',
                    permissions: ['view_invoices', 'admin'],
                    items: [
                        {
                            svgIcon: require('@/assets/svg/invoice_save.svg'),
                            label: 'Registrar factura',
                            route: '/registrar-factura',
                            permissions: ['register_invoices', 'admin']
                        },
                        {
                            svgIcon: require('@/assets/svg/massive_invoices_load.svg'),
                            label: 'Carga masiva facturas',
                            route: '/carga-masiva-facturas',
                            permissions: ['register_invoices', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-building',
                            label: 'Razones sociales',
                            route: '/razones-sociales',
                            permissions: ['view_invoices', 'admin']
                        },
                        {
                            svgIcon: require('@/assets/svg/invoices_show.svg'),
                            label: 'Ver facturas',
                            route: '/ver-facturas',
                            permissions: ['view_invoices', 'admin']
                        }
                    ]
                },
                {
                    icon: 'fa-solid fa-chart-line',
                    label: 'Operaciones',
                    permissions: ['radios', 'reports', 'admin'],
                    items: [
                        {
                            icon: 'fa-solid fa-chart-line',
                            label: 'KPI',
                            route: '/indicadores/operaciones/kpi',
                            permissions: ['reports', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-chart-simple',
                            label: 'Analítica',
                            route: '/indicadores/operaciones/analitica',
                            permissions: ['admin'],
                            badge: 'Beta'
                        },
                        {
                            icon: 'fa-solid fa-tower-broadcast',
                            label: 'Canales',
                            route: '/indicadores/operaciones/canales',
                            permissions: ['reports', 'admin']
                        },
                        {
                            icon: 'fa-solid fa-phone',
                            label: 'Llamadas y Minutas',
                            route: '/indicadores/operaciones/llamadas-minutas',
                            permissions: ['reports', 'admin']
                        }
                    ]
                },
            ],
        }
    },
    computed: {
        visibleSideBarItems() {
            return this.SideBarItems
                .map((item) => this.normalizeMenuItem(item))
                .filter(Boolean);
        },

        orderedVisibleSideBarItems() {
            return [...this.visibleSideBarItems].sort((a, b) => {
                const aOrder = this.getMenuDisplayOrder(a);
                const bOrder = this.getMenuDisplayOrder(b);

                if (aOrder === bOrder) {
                    return a.label.localeCompare(b.label, 'es');
                }

                return aOrder - bOrder;
            });
        },

        groupedMenuSections() {
            const grouped = this.menuSectionOrder.map((key) => ({
                key,
                title: this.menuSectionTitles[key] || key,
                items: []
            }));

            const groupedMap = grouped.reduce((acc, section) => {
                acc[section.key] = section;
                return acc;
            }, {});

            this.orderedVisibleSideBarItems.forEach((item) => {
                const sectionKey = this.getMenuSection(item);
                const targetSection = groupedMap[sectionKey] || groupedMap.operations;
                targetSection.items.push(item);
            });

            return grouped.filter((section) => section.items.length > 0);
        },
    },
 
    methods: {
        managerHref() {
            const token = localStorage.getItem('token') || '';
            return 'https://manager.vybroo.app/autologin#token=' + encodeURIComponent(token);
        },

        getItemKey(item) {
            return (item && (item.route || item.label)) || '';
        },

        getItemId(item) {
            const key = this.getItemKey(item);
            const slug = key
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '')
                .toLowerCase();
            return `menu-${slug || 'item'}`;
        },

        getMenuMeta(itemOrKey) {
            const key = typeof itemOrKey === 'string' ? itemOrKey : this.getItemKey(itemOrKey);
            return this.menuMetaByKey[key] || {};
        },

        normalizeMenuItem(item) {
            if (!this.hasAccess(item)) {
                return null;
            }

            if (!item.items) {
                if (!this.hasRoute(item) || this.isHiddenRoute(item.route)) {
                    return null;
                }

                return {
                    ...item,
                    id: this.getItemId(item)
                };
            }

            const visibleChildren = item.items
                .filter((child) => this.hasAccess(child) && this.hasRoute(child) && !this.isHiddenRoute(child.route))
                .map((child) => ({
                    ...child,
                    id: this.getItemId(child)
                }));

            if (visibleChildren.length === 0) {
                return null;
            }

            return {
                ...item,
                id: this.getItemId(item),
                items: visibleChildren
            };
        },

        initializeExpandedItems() {
            const nextExpanded = {};

            this.orderedVisibleSideBarItems.forEach((item) => {
                if (!item.items) {
                    return;
                }

                const hasActiveChild = item.items.some((child) => child.route === this.currentPath);
                const previousState = this.expandedItems[item.id];

                nextExpanded[item.id] = typeof previousState === 'boolean'
                    ? previousState
                    : this.expandStrategy === 'all' || hasActiveChild;

                if (hasActiveChild) {
                    nextExpanded[item.id] = true;
                }
            });

            this.expandedItems = nextExpanded;
        },

        ensureActiveParentExpanded() {
            const expandedSnapshot = { ...this.expandedItems };
            let hasChanges = false;

            this.orderedVisibleSideBarItems.forEach((item) => {
                if (!item.items) return;

                const hasActiveChild = item.items.some((child) => child.route === this.currentPath);
                if (hasActiveChild && !expandedSnapshot[item.id]) {
                    expandedSnapshot[item.id] = true;
                    hasChanges = true;
                }
            });

            if (hasChanges) {
                this.expandedItems = expandedSnapshot;
            }
        },

        getMenuSection(item) {
            const menuMeta = this.getMenuMeta(item);
            return menuMeta.section || 'operations';
        },

        getMenuDisplayOrder(item) {
            const menuMeta = this.getMenuMeta(item);
            return Number.isFinite(menuMeta.order) ? menuMeta.order : Number.MAX_SAFE_INTEGER;
        },

        hasRoute(item) {
            return !!(item && item.route);
        },

        isHiddenRoute(route) {
            if (!route) {
                return false;
            }

            const menuMeta = this.getMenuMeta(route);
            return !!menuMeta.hidden;
        },

        hasAccess(item) {
            const permissions = Array.isArray(item && item.permissions) ? item.permissions : [];
            return !permissions.length || permissions.some((permission) => this.user_permission.includes(permission));
        },

        isActiveRoute(route) {
            return !!route && this.currentPath === route;
        },

        syncCurrentPath(route) {
            this.currentPath = (route && route.path) || '';
        },

        toggleExpand(itemId) {
            this.expandedItems = {
                ...this.expandedItems,
                [itemId]: !this.expandedItems[itemId]
            };
        },

        isExpanded(itemId) {
            return !!this.expandedItems[itemId];
        },

        enter(element) {
            element.style.height = '0';
            element.style.opacity = '0';
            element.offsetHeight;
            requestAnimationFrame(() => {
                element.style.height = element.scrollHeight + 'px';
                element.style.opacity = '1';
            });
        },

        afterEnter(element) {
            element.style.height = 'auto';
        },

        leave(element) {
            element.style.height = element.scrollHeight + 'px';
            element.style.opacity = '1';
            element.offsetHeight;
            element.style.height = '0';
            element.style.opacity = '0';
        }
    },
    mounted() {
        if (localStorage.getItem('clientData') === null) {
            this.$router.push({ name: 'login' });
        } else { 
            const tokenId = JSON.parse(localStorage.getItem('clientData'));
            this.user_permission = tokenId.permissions;
        }

        this.initializeExpandedItems();
        this.ensureActiveParentExpanded();
    },
    created() {
        this.syncCurrentPath(this.$route);
    },
    watch: {
        '$route'(to) {
            this.syncCurrentPath(to);
            this.ensureActiveParentExpanded();
        },

        orderedVisibleSideBarItems: {
            immediate: true,
            handler() {
                this.initializeExpandedItems();
                this.ensureActiveParentExpanded();
            }
        }
    }
}
</script>

<style>
.p-tooltip-text {
    font-size: 10px !important;
}

#side-bar {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: width 0.28s ease-in-out, background-color 0.28s ease-in-out;
  background: var(--chrome-bg, #f3f4f6);
  border-right: 1px solid var(--chrome-border, rgba(148, 163, 184, 0.34));
}

.dark #side-bar {
    background: var(--chrome-bg, #18181b);
    border-right-color: var(--chrome-border, rgba(113, 113, 122, 0.52));
}

.sidebar-brand-row {
  flex-shrink: 0;
  border-bottom: 1px solid var(--chrome-border, rgba(148, 163, 184, 0.34));
}

.side-bar-visible {
    width: var(--sidebar-open-width, clamp(248px, 22vw, 296px));
}

.side-bar-close {
    width: var(--sidebar-closed-width, 74px);
}

.sidebar-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 10px;
}

/* ── CTA «Ir al manager» ── */
.sidebar-cta {
  flex-shrink: 0;
  padding: 10px 10px 12px;
  border-top: 1px solid var(--chrome-border, rgba(148, 163, 184, 0.34));
}
.dark .sidebar-cta {
  border-top-color: var(--chrome-border, rgba(113, 113, 122, 0.52));
}
.sidebar-manager-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.1;
  text-decoration: none;
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.28);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}
.sidebar-manager-btn:hover {
  filter: brightness(1.07);
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.34);
}
.sidebar-manager-btn:active {
  transform: translateY(0);
}
.sidebar-manager-btn .sp-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-manager-closed {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}
.sidebar-manager-open {
  justify-content: flex-start;
}

.sidebar-content::-webkit-scrollbar {
    width: 8px;
}

.sidebar-content::-webkit-scrollbar-thumb {
    border-radius: 12px;
    background: rgba(100, 116, 139, 0.35);
}

.dark .sidebar-content::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.26);
}

.sidebar-content a {
    font-size: 14px;
    line-height: 1.1;
}

.menu-section-title {
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #475569;
}

.menu-section-block {
    border-top: 1px solid rgba(148, 163, 184, 0.3);
    margin-top: 8px;
    padding-top: 8px;
}

.menu-section-block:first-child {
    border-top: 0;
    padding-top: 0;
}

.dark .menu-section-title {
    color: #a1a1aa;
}

.dark .menu-section-block {
    border-top-color: rgba(113, 113, 122, 0.44);
}

.list-button-sb,
.sidebarPadre {
    border-radius: 10px;
    color: #0f172a;
    font-weight: 600;
    transition: background-color 0.18s ease, color 0.18s ease;
}

.list-button-sb:hover,
.sidebarPadre:hover {
    background: rgba(148, 163, 184, 0.18);
}

.dark .list-button-sb,
.dark .sidebarPadre {
    color: #e4e4e7;
}

.dark .list-button-sb:hover,
.dark .sidebarPadre:hover {
    background: rgba(107, 114, 128, 0.34);
}

.Selected_Sidebar {
    color: #0b1220;
    font-weight: 700;
    background: rgba(59, 130, 246, 0.12);
    box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.25);
}

.dark .Selected_Sidebar {
    color: #f3f4f6;
    background: rgba(148, 163, 184, 0.24);
    box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.36);
}

.list-button-sb .sp-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.menu-icon-wrap {
    width: 18px;
    min-width: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.menu-parent-content-open,
.sidebar-link-open {
    gap: 8px;
}

.side-bar-close .sidebar-link-closed,
.side-bar-close .sidebarPadre {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
}

.side-bar-close .menu-parent-content-closed {
    width: 100%;
    justify-content: center;
}

.sidebarHijo {
    padding-left: 10px;
}

.sidebarHijoClosed {
    padding-left: 0px;
}

.collapse-enter-active,
.collapse-leave-active {
    transition: height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to {
    height: 0;
}

.rotate-180 {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
}

.menu-badge {
    font-size: 0.55rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    padding: 1px 5px;
    border-radius: 4px;
    background: #f59e0b;
    color: #fff;
    text-transform: uppercase;
    line-height: 1.3;
    margin-left: auto;
}

.dark .menu-badge {
    background: #d97706;
}

.logo-invert {
    filter: invert(1);
}

.dark .logo-invert {
    filter: invert(0);
}

.sidebar-icon {
    display: inline-block;
    vertical-align: middle;
    filter: brightness(0) saturate(100%) invert(10%) sepia(20%) saturate(1562%) hue-rotate(196deg) brightness(93%) contrast(96%);
}

.dark .sidebar-icon {
    filter: brightness(0) saturate(100%) invert(88%) sepia(4%) saturate(404%) hue-rotate(182deg) brightness(97%) contrast(92%);
}

.Selected_Sidebar .sidebar-icon {
    filter: brightness(0) saturate(100%) invert(10%) sepia(20%) saturate(1562%) hue-rotate(196deg) brightness(93%) contrast(96%);
}

.dark .Selected_Sidebar .sidebar-icon {
    filter: brightness(0) saturate(100%) invert(97%) sepia(4%) saturate(196%) hue-rotate(189deg) brightness(103%) contrast(96%);
}
</style>
